var map = {
	"./Color/Index.vue": "67da",
	"./Color/__ColorModal.vue": "cc5b",
	"./Config.vue": "5ebf",
	"./Customer/__UserManageModal.vue": "aeaf",
	"./Customer/components/CustomerContact.vue": "79fc",
	"./Customer/components/CustomerContactModal.vue": "1dd1",
	"./Customer/components/CustomerModal.vue": "0381",
	"./Customer/components/HistoryQuota.vue": "5e85",
	"./Customer/index.vue": "ffd3",
	"./Danger.vue": "f1f3",
	"./Dashboard/__PageVisitsTable.vue": "f5ba",
	"./Dashboard/__SocialTrafficTable.vue": "4f46",
	"./Debt/Index copy.vue": "2bf4",
	"./Debt/Index.vue": "69ce",
	"./Debt/__Preview.vue": "4afe",
	"./Login.vue": "013f",
	"./Manufacture/Add.vue": "2a29",
	"./Manufacture/Index.vue": "2754",
	"./Manufacture/__Preview.vue": "5814",
	"./Manufacture/__Status.vue": "f6d5",
	"./NotFound.vue": "aa4b",
	"./Order/Add.vue": "516b",
	"./Order/Index.vue": "6a66",
	"./Order/__AddPayment.vue": "ad55",
	"./Order/__CreateInvoice.vue": "7005",
	"./Order/__HistoriesManufacture.vue": "74fc",
	"./Order/__Preview.vue": "74e6",
	"./Permission.vue": "206c",
	"./Product/_SpecFeatueFormModal.vue": "5d99",
	"./Product/__ConvertUnit.vue": "5bc4",
	"./Product/__HistoryProductInfo.vue": "14e0",
	"./Product/__Product.vue": "2342",
	"./Product/__ProductInfo.vue": "e880",
	"./Product/__ProductInfoModal.vue": "5b22",
	"./Product/__ProductModal.vue": "7e04",
	"./Product/__Reason.vue": "1e7c",
	"./Product/__SpecFeatureModal.vue": "46dc",
	"./Product/__SpecModal.vue": "94b8",
	"./Product/__SpecProduct.vue": "16cd",
	"./Product/__SpecProductUnit.vue": "540a",
	"./Product/index copy.vue": "503b",
	"./Product/index.vue": "7e79",
	"./Quotation/Add.vue": "6a5f",
	"./Quotation/Index.vue": "f69c",
	"./Quotation/__History.vue": "4dc4",
	"./Quotation/__Preview.vue": "b03b",
	"./Register.vue": "56b4",
	"./Report/HistoryPayment.vue": "e94b",
	"./Report/Turnover.vue": "f5fe",
	"./Report/TurnoverUser.vue": "e6ec",
	"./Report/__Preview.vue": "35a1",
	"./Role/FeatureGroupModal.vue": "5bfd",
	"./Role/FeatureModal.vue": "e5ad",
	"./Role/Index.vue": "cd77",
	"./Role/RoleModal.vue": "535f",
	"./Tem/Add.vue": "bb30",
	"./Tem/ScannerTem copy.vue": "d555",
	"./Tem/ScannerTem.vue": "01aa",
	"./Tem/TemManage.vue": "e8ce",
	"./Tem/__AddTemModal.vue": "df49",
	"./Tem/__CancelTemModal.vue": "5bfa",
	"./Tem/__PreviewTem.vue": "d7b0",
	"./Tem/__TemBao.vue": "eb82",
	"./Tem/__TemBaoCS.vue": "4181",
	"./Tem/__TemBaoOdd.vue": "28a5b",
	"./Tem/__TemBaoPreview.vue": "cc40",
	"./Tem/__TemBich.vue": "4516",
	"./Tem/__TemBichCS.vue": "e1d6",
	"./Tem/__TemBichOdd.vue": "3734",
	"./Tem/__TemBichPreview.vue": "d060",
	"./Tem/__TemDH.vue": "1b2c",
	"./Tem/__TemLoi.vue": "b69c",
	"./User/Index.vue": "c1a9",
	"./User/__PermissionModal.vue": "d528",
	"./User/__UserModal.vue": "33d4",
	"./UserProfile.vue": "4336",
	"./Verify.vue": "071b",
	"./Warehouse/CreateIn.vue": "8bc7",
	"./Warehouse/CreateOut.vue": "24b6",
	"./Warehouse/ReturnGood.vue": "b509",
	"./Warehouse/Scanner.vue": "0802",
	"./Warehouse/__Preview.vue": "57c2",
	"./Warehouse/__PreviewOut.vue": "4469",
	"./Warehouse/__ReceiptIn.vue": "db3a",
	"./Warehouse/__ReceiptOut.vue": "85c3",
	"./Warehouse/__ReturnModal.vue": "cc0a",
	"./Warehouse/index.vue": "0342",
	"./index copy.vue": "5b2b",
	"./index.vue": "9261"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f2";